// src/pages/HomeRoomAttendancePage.jsx
import React, { useEffect } from "react";
import {
  Card,
  Table,
  Typography,
  Spin,
  Alert,
  Tag,
  Empty,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomeRoomAttendance } from "../../store/attendanceSlice";

const { Title } = Typography;

const HomeRoomAttendancePage = () => {
  const dispatch = useDispatch();

  // Get user info from session or local storage
  const userInfo =
    JSON.parse(sessionStorage.getItem("userInfo")) ||
    JSON.parse(localStorage.getItem("userInfo")) ||
    {};

  // Determine studentId based on role
  let studentId = null;
  if (
    Array.isArray(userInfo.roles) &&
    userInfo.roles.includes("Student") &&
    Array.isArray(userInfo.studentIds) &&
    userInfo.studentIds.length > 0
  ) {
    studentId = userInfo.studentIds[0];
  }

  const { homeRoomAttendance, loading, error } = useSelector(
    (state) => state.attendance
  );

  useEffect(() => {
    if (studentId) {
      dispatch(fetchHomeRoomAttendance(studentId));
    }
  }, [dispatch, studentId]);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      responsive: ["xs", "sm", "md", "lg"],
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Room",
      dataIndex: ["scheduleSlot", "room", "roomName"],
      key: "room",
      responsive: ["sm", "md", "lg"],
    },
    {
      title: "Period",
      key: "period",
      responsive: ["sm", "md", "lg"],
      render: (_, record) =>
        record?.scheduleSlot?.schoolDay?.period?.periodName || "N/A",
    },
    {
      title: "Start Time",
      key: "startTime",
      responsive: ["md", "lg"],
      render: (_, record) =>
        record?.scheduleSlot?.schoolDay?.period?.startTime?.slice(0, 5) || "-",
    },
    {
      title: "End Time",
      key: "endTime",
      responsive: ["md", "lg"],
      render: (_, record) =>
        record?.scheduleSlot?.schoolDay?.period?.endTime?.slice(0, 5) || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === 1 ? "green" : "red"}>
          {status === 1 ? "Present" : "Absent"}
        </Tag>
      ),
    },
  ];

  const cardStyle = {
    maxWidth: "1000px",
    margin: "auto",
    marginTop: "20px",
    padding: "10px",
  };

  const headerStyle = {
    textAlign: "center",
    marginTop: "10px",
  };

  return (
    <div style={{ padding: "10px" }}>
      <Title level={3} style={headerStyle}>
        Homeroom Attendance Report
      </Title>

      <Card style={cardStyle} bordered={false} bodyStyle={{ padding: "10px" }}>
        {loading ? (
          <Spin size="large" style={{ display: "block", margin: "auto" }} />
        ) : error ? (
          <Alert type="error" message={error} showIcon />
        ) : homeRoomAttendance.length === 0 ? (
          <Empty description="No attendance records found." />
        ) : (
          <Table
            dataSource={homeRoomAttendance}
            columns={columns}
            rowKey={(record) => record.accID}
            pagination={{ pageSize: 5 }}
            scroll={{ x: 600 }}
          />
        )}
      </Card>
    </div>
  );
};

export default HomeRoomAttendancePage;
